import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { MetaApiResponse } from '@/utils/types/CommonApiResponse';
import { getBusinessUsageAnalytics, getBusinessUsageBreakdown, getBusinessUsageOverview } from './api';
import { BusinessUsageBreakdown, BusinessUsageOverview } from './types';

export function useGetBusinessUsageAnalytics(params?: Record<string, any>, options?: UseQueryOptions<any, Error>) {
  return useQuery<any>({
    queryKey: ['business_usage_analytics', params],
    queryFn: () => getBusinessUsageAnalytics(params),
    ...options
  });
}

export function useGetBusinessUsageBreakdown(
  params?: Record<string, any>,
  options?: UseQueryOptions<{ data: BusinessUsageBreakdown[]; meta: MetaApiResponse }, Error>
) {
  return useQuery<{ data: any[]; meta: MetaApiResponse }>({
    queryKey: ['business_usage_breakdown', params],
    queryFn: () => getBusinessUsageBreakdown(params),
    ...options
  });
}

export function useGetBusinessUsageOverview(
  params?: Record<string, any>,
  options?: Partial<UseQueryOptions<BusinessUsageOverview, Error>>
) {
  return useQuery<BusinessUsageOverview, Error>({
    queryKey: ['business_usage_overview', params],
    queryFn: () => getBusinessUsageOverview(params),
    ...options
  });
}
